import { API_URL } from './constants'

type MailBody = {
  firstName: string
  lastName: string
  email: string
  interests?: string
  companyName?: string
  inquiry?: string
  phone?: string
  event?: string
  recaptcha: string
}

export const sendMail = (body: MailBody | FormData, recaptcha?: string): Promise<Response> => {
  return fetch(`${API_URL}/mail`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json;charset=utf-8',
      ...(recaptcha ? { recaptcha } : {}),
    },
    body: JSON.stringify(body),
  })
}
